// Get the anchor element
var openModalAnchor = document.getElementById('obStatement');

// Add click event listener to the anchor
openModalAnchor.addEventListener('click', function (event) {
  // Prevent default anchor behavior
  event.preventDefault();

  // Define your dynamic content here
  var dynamicContent = document.querySelector("[data-id='accessibility-statement']");
  if (dynamicContent) openUIModal(dynamicContent.innerHTML); // Open modal with dynamic content
});
